import * as D from '../../../utils/dbmodel';

export default {
    namespaced: true,
    state: {
        list: [], //table中的list显示数据
        pagination: {}, //分页相关的信息
        record: {}, //根据id查询的数据详情信息

        configlist: [], //table中的list显示数据
        configpagination: {}, //分页相关的信息
        configdata: {},
    },
    getters: {
    },
    mutations: {
        save(state, action) {
            for (var key in action.payload) {
                state[key] = action.payload[key]
            }
        }
    },
    actions: {
        //查询list列表
        syslist(context, payload) {
            payload.type = 'rc/io/syslist'
            // console.log(payload, "payload----------")
            return D.select(payload).then(response => {
                const { data } = response.data
                context.commit({
                    type: 'save',
                    payload: {
                        list: data.list || [],
                        pagination: {
                            total: +data.totalRecords,
                            current: +data.page,
                            pageSize: +data.pageSize,
                        }
                    }
                })
            })
        },
        //配置列表查询
        configlist(context, payload) {
            payload.type = 'rc/io/configlist'
            // console.log(payload, "payload----------")
            return D.select(payload).then(response => {
                const data = response.data.data || {}
                const pageInfo = data.pageInfo || {}

                context.commit({
                    type: 'save',
                    payload: {
                        configdata: data || {},
                        configlist: pageInfo.list ? pageInfo.list : [],
                        configpagination: {
                            total: +pageInfo.totalRecords,
                            current: +pageInfo.page,
                            pageSize: +pageInfo.pageSize,
                        }
                    }
                })
            })
        },
        //新增服务器
        addserver(context, payload) {
            payload.type = 'rc/io/addserver'
            return D.add(payload).then(response => {
                //重新加载一次数据
                context.dispatch({ type: 'syslist' })
                return response
            })
        },
        sysadd(context, payload) {
            payload.type = 'rc/io/sysadd'
            return D.add(payload).then(response => {
                //重新加载一次数据
                context.dispatch({ type: 'syslist' })
                return response
            })
        },
        //添加配置
        addconfig(context, payload) {
            payload.type = 'rc/io/addconfig'
            return D.add(payload).then(response => {
                //重新加载一次数据
                context.dispatch({ type: 'configlist' })
                return response
            })
        },
        //编辑配置
        editconfig(context, payload) {
            payload.type = 'rc/io/editconfig'
            return D.edit(payload).then(response => {
                //重新加载一次数据
                context.dispatch({ type: 'configlist' })
                return response
            })
        },
        //修改状态
        editflag(context, payload) {
            payload.type = 'rc/io/editflag'
            return D.edit(payload).then(response => {
                //重新加载一次数据
                context.dispatch({ type: 'configlist' })
                return response
            })
        },
        //删除
        delserver(context, payload) {
            payload.type = 'rc/io/delserver'
            return D.del(payload).then(response => {
                //重新加载一次数据
                context.dispatch({ type: 'syslist' })
                return response
            })
        },
        //删除配置
        delconfig(context, payload) {
            payload.type = 'rc/io/delconfig'

            return D.del(payload).then(response => {
                //重新加载一次数据
                context.dispatch({ type: 'configlist' })
                return response
            })
        },
        //复制
        copyserver(context, payload) {
            payload.type = 'rc/io/copyserver'

            return D.del(payload).then(response => {
                //重新加载一次数据
                context.dispatch({ type: 'syslist' })
                return response
            })
        },
        //刷新
        refreshserver(context, payload) {
            payload.type = 'rc/io/refreshserver'

            return D.del(payload).then(response => {
                //重新加载一次数据
                context.dispatch({ type: 'syslist' })
                return response
            })
        },
        //详情
        // detail(context, payload) {
        //     return D.detail(payload).then(response => {
        //         const { data } = response.data
        //         context.commit({
        //             type: 'save',
        //             payload: {
        //                 record: data
        //             }
        //         })
        //         return response
        //     })
        // },
    }
}
